import type { MissionFilterId } from '../constants/status'

/** Só o que a correspondência precisa — nada de tipo arrastando cadeia de UI. */
export type MissionMatchable = {
  uiStatus: string
  isNew: boolean
  isRecommended: boolean
  isEndingSoon: boolean
}

/**
 * Correspondência item ↔ filtro em missões.
 *
 * Três dos filtros **não** são status, e é por isso que a correspondência não
 * pode ser `item.uiStatus === filter`:
 *
 * - `ativas` cobre dois status ao mesmo tempo (`available` e `progress`)
 * - `ending` é janela de tempo (24h para o término)
 * - `recommended` é ranking por recompensa, e só vale para missão ativa
 * - `new` é recência (janela de 1h), eixo independente do progresso
 *
 * Módulo próprio, e não closure no hook: a suíte roda em `environment: 'node'` e
 * importar o hook arrastaria a cadeia de stores e de componentes.
 */
export const matchesMissionFilter = (
  item: MissionMatchable,
  filter: MissionFilterId
): boolean => {
  switch (filter) {
    case 'all':
      return true
    case 'new':
      return item.isNew
    case 'ativas':
      return item.uiStatus === 'available' || item.uiStatus === 'progress'
    case 'ending':
      return item.isEndingSoon
    case 'recommended':
      return (
        item.isRecommended &&
        (item.uiStatus === 'available' || item.uiStatus === 'progress')
      )
    default:
      return item.uiStatus === filter
  }
}
